/* eslint no-unused-vars: off */
// External library
import Swiper from 'swiper/bundle'

// Component
export default () => {
    const els = document
        .querySelectorAll('.featured-products')

    if (!els)
        return

    els.forEach((el) => {
        const swiperEl = el
            && el.querySelector('[data-featured-products]')

        if (!swiperEl)
            return

        const nextEl = el
            .querySelector('.swiper-button-next')

        const prevEl = el
            .querySelector('.swiper-button-prev')

        const fractionEl = el
            .querySelector('.swiper-fraction')

        const scrollbarEl = el
            .querySelector('.swiper-scrollbar')

        const swiper = new Swiper(swiperEl, {
            freeMode: true,
            keyboard: {
                enabled: true
            },
            pagination: {
                el: fractionEl,
                type: 'fraction'
            },
            scrollbar: {
                el: scrollbarEl,
                hide: false
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            navigation: {
                nextEl,
                prevEl
            }
        })
    })
}
